// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GbsJ1","load1":"Spinner_load1__dZPct","fullPage":"Spinner_fullPage__4fo0T"};